import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_generic_doc_approval_setting_RowClass} from '../../../dbschema';

export class GenericDocApprovalSettingContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_approval_setting: bl_fi_generic_doc_approval_setting_RowClass = new bl_fi_generic_doc_approval_setting_RowClass();
}
